<template>
  <v-dialog
    v-model="dialog"
  >
    <v-data-table
      :headers="headers"
      :items="users"
      :loading="loading"
      class="elevation-1"
      :items-per-page="-1"
      hide-default-footer
    >
      <template v-for="map in maps" v-slot:[`item.${map}`]="{ item }">
        <td :key="map">
          <div v-if="item[map]" class="d-flex justify-space-between">
            <div class="text-center" :style="{ width: '100%' }">
              <b>{{ (item[map][0] / item[map][3]).toFixed(2) }}</b>
            </div>
            <div class="text-center" :style="{ width: '100%' }">{{ item[map][1].toFixed(2) }}</div>
            <div class="text-center" :style="{ width: '100%' }">{{ item[map][2].toFixed(2) }}</div>
          </div>
          <div v-else class="text-center" :style="{ width: '100%' }">-</div>
        </td>
      </template>
    </v-data-table>
  </v-dialog>
</template>

<script>
import helper from '../../../plugins/helpers/mixin-helper'
export default {
  mixins: [
    helper
  ],
  data () {
    return {
      dialog: true,
      loading: false,
      maps: [],
      users: [],
      headers: []
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    }
  },
  async mounted () {
    await this.getData()
  },
  methods: {
    close () {
      this.$emit('close')
    },
    async getData () {
      if (!this.$route.query.build_id && !this.$route.query.user_id && !this.$route.query.session_id) {
        return
      }

      this.loading = true
      const { data } = await this.$axios.get(
        `${this.$store.getters.projectPath}/telemetry/playtime/distance/${this.$route.query.map_id}`, {
          params: {
            build_id: this.$route.query.build_id,
            user_id: this.$route.query.user_id,
            session_id: this.$route.query.session_id,
            start_narration_node: this.$route.query.start_narration_node,
            finish_narration_node: this.$route.query.finish_narration_node,
            finish_event_id: this.$route.query.finish && this.$route.query.finish !== 'null' ? this.$route.query.finish[1] : null,
            filteredByPlayer: true,
            session_min_time: this.$route.query.session_min_time
          }
        }
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.users = data.users
        this.maps = data.maps
        this.headers = [{
          text: 'Player',
          align: 'start',
          sortable: true,
          class: 'sticky-col',
          cellClass: 'sticky-col',
          value: 'PlayerNickname'
        }].concat(data.maps.map(map => ({
          text: map,
          align: 'center',
          sortable: false,
          value: map
        })).sort((a, b) => {
          if (a.text > b.text) return 1
          if (a.text < b.text) return -1
          return 0
        }))
      }
      this.loading = false
    }
  }
}
</script>

<style lang="css">
  .sticky-col {
    position: sticky;
    left: 0;
    background-color: white;
    z-index: 1;
  }
</style>
